import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { HelpWidgetConversation } from "../types/help_widget_conversation";

interface UseSubmitConversationProps {
  chatBotSessionId: string;
  onError: (error: any) => void;
  onSuccess: (ticket: any) => void;
  source: string;
}

interface SubmitConversationProps {
  conversation: HelpWidgetConversation;
  id: string;
}

export const useSubmitConversation = ({
  onSuccess,
  onError,
  source,
  chatBotSessionId,
}: UseSubmitConversationProps) =>
  useMutation({
    mutationFn: async ({ id, conversation }: SubmitConversationProps) =>
      reactQueryPost(internalApi.helpWidget.submitConversation({ id }), {
        id,
        conversation,
        submit_page_url: window.location.href,
        source,
        chat_bot_session_id: chatBotSessionId,
        viewport_height: String(
          window.innerHeight || document.documentElement.clientHeight,
        ),
        viewport_width: String(
          window.innerWidth || document.documentElement.clientWidth,
        ),
      }),
    onSuccess: data => onSuccess(data.ticket),
    onError: onError,
  });
